<template lang="pug">
.wrapper.container-fluid.bg-transparent
  side-bar(
    :background-color="sidebarBackground",
    short-title="M2M",
    title="M2M",
    :logo="require('@/assets/favicon.png')"
  )
    template.text-danger(slot="links")
      sidebar-item(
        :link="{ name: this.$t('dashboard'), icon: 'ni ni-tv-2 text-primary', path: '/dashboard' }"
      )
      sidebar-item(
        :link="{ name: this.$t('companies'), icon: 'ni ni-bullet-list-67 text-red', path: '/companies' }",
        v-if="can('super_admin;admin;member')"
      )
      //- sidebar-item(:link="{name: this.$t('products'), icon: 'ni ni-tag text-yellow', path: '/products'}")
      sidebar-item(
        :link="{ name: this.$t('users'), icon: 'ni ni-single-02 text-success', path: '/users' }",
        v-if="can('super_admin;admin;member')"
      )
      sidebar-item(
        :link="{ name: this.$t('advertising-service'), icon: 'ri-profile-line text-primary', path: '/advertising-service' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('advertising'), icon: 'ri-profile-line text-info', path: '/advertising' }"
      )
      sidebar-item(
        :link="{ name: this.$t('rewards'), icon: 'ri-money-dollar-box-line text-warning', path: '/rewards' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('conditions'), icon: 'ni ni-planet text-blue', path: '/terms-and-conditions' }",
        v-if="can('super_admin')"
      )
      //- sidebar-item(
      //-   :link="{ name: this.$t('e-commerce'), icon: 'ni ni-cart text-info', path: '/ecommerce' }"
      //- )
      sidebar-item(
        :link="{ name: this.$t('transactions'), icon: 'ri-history-line', path: '/history/transactions' }"
      )
      sidebar-item(
        :link="{ name: this.$t('words'), icon: 'ri-money-dollar-box-line text-warning', path: '/admin/words' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('exchange'), icon: 'ri-money-dollar-box-line text-warning', path: '/admin/words/counts' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('transfers-pending'), icon: 'ri-bank-line text-info', path: '/transfers-pending' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('settings'), icon: 'ri-settings-3-line', path: '/settings' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('convertions'), icon: 'ri-creative-commons-sa-line text-success', path: '/convertions' }",
        v-if="can('super_admin')"
      )
      sidebar-item(
        :link="{ name: this.$t('coupons'), icon: 'ri-coupon-3-line text-danger', path: '/coupons' }"
      )
      sidebar-item(
        :link="{ name: this.$t('tickets-suports'), icon: 'ri-coupon-line text-primary', path: '/tickets-suports' }",
        v-if="can('super_admin')"
      )
  .main-content(:data="sidebarBackground")
    dashboard-navbar
    div(@click="toggleSidebar")
      fade-transition(:duration="200", origin="center top", mode="out-in")
        router-view
      content-footer(v-if="!$route.meta.hideFooter")
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters } from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>